import React from 'react';
import {Rating} from "@mui/material";

import styles from './ReviewFromCustomer.module.scss';

const ReviewFromCustomer = ({feedback, order}) => {
    const {feedback_text, private_feedback_text, service_feedback} = feedback;

    return (
        <div className={styles.reviewFromCustomer}>
            <p className={styles.reviewFromCustomer_title}>Відгук клієнта</p>

            <div className={styles.reviewFromCustomer_review}>
                <p className={styles.reviewFromCustomer_review_subtitle}>Відгук</p>
                <p className={styles.reviewFromCustomer_review_content}>{feedback_text}</p>
            </div>

            {private_feedback_text && <div className={styles.reviewFromCustomer_review}>
                <p className={styles.reviewFromCustomer_review_subtitle}>Приватний відгук</p>
                <p className={styles.reviewFromCustomer_review_content}>{private_feedback_text}</p>
            </div>}

            <div className={styles.reviewFromCustomer_block}>
                <p className={styles.reviewFromCustomer_block_subtitle}>Якість обслуговування</p>
                <Rating
                    style={{fontSize: '24px'}}
                    size="large"
                    name="read-only"
                    readOnly
                    value={service_feedback?.[0]?.assessment}
                />
            </div>

            <div className={styles.reviewFromCustomer_block}>
                <p className={styles.reviewFromCustomer_block_subtitle}>Якість наданої послуги
                    ({order?.cleaning_type})</p>
                <Rating
                    style={{fontSize: '24px'}}
                    size="large"
                    name="read-only"
                    readOnly
                    value={service_feedback?.[0]?.service}
                />
            </div>
        </div>
    );
};

export default ReviewFromCustomer;
